module.exports = __webpack_public_path__ + "img/gel-100.f5b2ff4e.jpg";